/**
 * `core/wordpress/mwwpform/mwwpformScriptLoader.js`
 * - jQuery, MW WP Form のスクリプトを動的ロード
 *
 * 使用方法:
 * - import {mwwpformScriptLoader} from "../wordpress/mwwpform/mwwpformScriptLoader.js";
 */


export function mwwpformScriptLoader() {
  console.log("📜 Loading MW WP Form Scripts...");

  const scripts = [
    { id: "jquery-core-js", src: "/wp/wp-includes/js/jquery/jquery.min.js" },
    { id: "jquery-migrate-js", src: "/wp/wp-includes/js/jquery/jquery-migrate.min.js" },
    { id: "mw-wp-form-js", src: "/wp/wp-content/plugins/mw-wp-form/js/form.js" },
  ];

  loadScriptsSequentially(scripts);
}


/**
 * 指定されたスクリプトを順番にロードする関数
 */
function loadScriptsSequentially(scripts, index = 0) {
  if (index >= scripts.length) return; // すべてのスクリプトが読み込まれたら終了

  const { id, src } = scripts[index];

  if (!document.getElementById(id)) {
    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.async = false; // 順番を守るため `async=false`

    script.onload = () => {
      console.log(`✅ Loaded: ${src}`);
      loadScriptsSequentially(scripts, index + 1); // 次のスクリプトをロード
    };

    script.onerror = () => {
      console.error(`❌ Failed to load: ${src}`);
    };

    document.body.appendChild(script);
  } else {
    console.log(`🔄 Already loaded: ${src}`);
    loadScriptsSequentially(scripts, index + 1); // すでに存在する場合も次へ
  }
}